module.exports = __webpack_public_path__ + "img/7.87b9b6a.jpg";